import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as inventoryAction from "../../../../actions/inventoryAction";
import Inventory from "./Inventory";

const mapStateToProps = (state) => {
  return {
    inventoryReducer: state.inventoryReducer
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListInventory: (params) =>
      dispatch(inventoryAction.getListInventory(params)),
    deleteInventory: (inventory, refreshParams) =>
      dispatch(inventoryAction.deleteInventory(inventory, refreshParams)),
  };
};

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(Inventory)
);
